const fragment = `
  id
  name
  imageUrl
  description
  units {
    id
    name
    floor
    price
    availability
    floorLocation
    view
    designedObject
    buildingModel {
      id
      name
      imageUrl
      bedrooms
      bathrooms
    }
    buildingFloor {
      id
    }
  }
`;

export const listBuildingFloorsQuery = `
  query ListBuildingFloors(
    $filter: BuildingFloorFilterInput
  ) {
    items: listBuildingFloors(filter: $filter) {
      ${fragment}
    }
  }
`;

export const getBuildingFloorQuery = `
  query GetBuildingFloor($id: Int!) {
    item: getBuildingFloor(id: $id) {
      ${fragment}
    }
  }
`;

export const createBuildingFloorQuery = `
  mutation CreateBuildingFloorQuery(
    $input: CreateBuildingFloorInput!
    $image: Upload
  ) {
    item: createBuildingFloor(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const updateBuildingFloorQuery = `
  mutation UpdateBuildingFloor(
    $input: UpdateBuildingFloorInput!
    $image: Upload
  ) {
    item: updateBuildingFloor(input: $input, image: $image) {
      ${fragment}
    }
  }
`;

export const deleteBuildingFloorQuery = `
  mutation DeleteBuildingFloor($id: Int!) {
    item: deleteBuildingFloor(id: $id) {
      ${fragment}
    }
  }
`;

export const setBuildingFloorUnitsQuery = `
  mutation SetBuildingFloorUnits(
    $input: SetBuildingFloorUnitsInput!
  ) {
    item: setBuildingFloorUnits(input: $input) {
      ${fragment}
    }
  }
`;

export const sortBuildingFloorsQuery = `
  mutation SortBuildingFloors(
    $ids: [Int!]!
  ) {
    items: sortBuildingFloors(ids: $ids) {
      ${fragment}
    }
  }
`;
